import type { Category } from './category';

const ACCENT_VAR: Record<Category, string> = {
  metro: 'var(--cat-metro)',
  bus: 'var(--cat-bus)',
  ride: 'var(--cat-ride)',
  pass: 'var(--cat-pass)',
};

/**
 * A two-stop origin → destination journey line (filled origin dot, connector, hollow destination
 * dot), reusing the timeline grammar (`wb-tl-*`). The boarding-pass hero for a metro/bus ticket.
 */
export function JourneyLine({
  from,
  to,
  accent = 'metro',
}: {
  from: string;
  to: string;
  accent?: Category;
}) {
  const color = ACCENT_VAR[accent];
  return (
    <div className="wb-timeline" role="list" aria-label={`Journey from ${from} to ${to}`}>
      <div className="wb-tl-row" role="listitem">
        <div className="wb-tl-rail">
          <span
            className="wb-tl-node"
            style={{ borderColor: color, background: color }}
            aria-hidden
          />
          <span className="wb-tl-line" style={{ background: color, minHeight: 26 }} aria-hidden />
        </div>
        <div className="wb-tl-label" style={{ paddingBottom: 18 }}>
          <span className="wb-eyebrow">From</span>
          <div className="wb-strong">{from}</div>
        </div>
      </div>
      <div className="wb-tl-row" role="listitem">
        <div className="wb-tl-rail">
          <span
            className="wb-tl-node"
            style={{ borderColor: color, background: 'var(--surface)' }}
            aria-hidden
          />
        </div>
        <div className="wb-tl-label" style={{ paddingBottom: 0 }}>
          <span className="wb-eyebrow">To</span>
          <div className="wb-strong">{to}</div>
        </div>
      </div>
    </div>
  );
}
